/**
 * Banwood Cap Bundle — cap-bundle.js
 * Full rebuild matching banwood-caps-landing.html design
 */
(function () {
  'use strict';

  // ─── CONFIG ────────────────────────────────────────────────────────────────
  const PROXY_URL = 'https://banwood-bundle-proxy.vercel.app/api/create-draft-order';

  const DISCOUNT_TIERS = [
    { minQty: 3, pct: 35 },
    { minQty: 2, pct: 25 },
    { minQty: 1, pct: 15 },
    { minQty: 0, pct: 0  },
  ];

  // ─── QUIZ ──────────────────────────────────────────────────────────────────
  const VIBE_COLOURS = {
    earthy:  [
      { name: 'Sage',  hex: '#b8c4aa', desc: 'Earthy, understated, always looks intentional.' },
      { name: 'Brown', hex: '#9b7b5a', desc: 'Warm, grounded, effortlessly cool.' },
    ],
    neutral: [
      { name: 'Cream', hex: '#efe8dc', desc: 'Clean, timeless, never overdone.' },
    ],
    cool:    [
      { name: 'Denim', hex: '#7090a8', desc: 'Cool, classic, goes with everything.' },
      { name: 'Mint',  hex: '#b8d4cc', desc: 'Fresh energy, every single time.' },
    ],
    soft:    [
      { name: 'Pink',  hex: '#e8c4b8', desc: 'Soft but confident. The kind of colour people notice.' },
    ],
  };

  const CAP_RESULTS = {
    '5panel': { type: '5 Panel Cap',        filter: '5-panel' },
    'washed': { type: 'Washed Baseball Cap', filter: 'washed'  },
  };

  // ─── STATE ─────────────────────────────────────────────────────────────────
  let bundleItems = [];
  let quizScores  = { '5panel': 0, 'washed': 0 };
  let quizVibe    = null;
  let currentStep = 0;
  const totalSteps = 4; // steps 0–3

  // ─── UTILITIES ─────────────────────────────────────────────────────────────
  function formatMoney(cents) { return '$' + (cents / 100).toFixed(2); }
  function getTier(qty) { return DISCOUNT_TIERS.find(t => qty >= t.minQty); }
  function applyDiscount(cents, pct) { return Math.round(cents * (1 - pct / 100)); }

  const quizSteps = document.querySelectorAll('.cb-quiz-step');
  const quizPips  = document.querySelectorAll('.cb-quiz-pip');

  function isMobile() { return window.innerWidth <= 600; }

  function goToStep(step) {
    quizSteps.forEach(s => s.classList.remove('cb-quiz-step--active'));
    const target = document.querySelector(`.cb-quiz-step[data-step="${step}"]`);
    if (target) target.classList.add('cb-quiz-step--active');
    currentStep = step;
    quizPips.forEach((p, i) => {
      p.classList.remove('cb-quiz-pip--active', 'cb-quiz-pip--done');
      if (i === step) p.classList.add('cb-quiz-pip--active');
      else if (i < step) p.classList.add('cb-quiz-pip--done');
    });
    // Mobile: scroll so quiz section sits at top of viewport
    if (isMobile()) {
      setTimeout(() => {
        const quizSection = document.getElementById('cb-quiz');
        if (quizSection) {
          const top = quizSection.getBoundingClientRect().top + window.scrollY - 8;
          window.scrollTo({ top, behavior: 'smooth' });
        }
      }, 50);
    }
    // Mobile: hide next button for new step until option is selected
    if (isMobile()) {
      const nextBtn = document.getElementById(`next-${step}`);
      if (nextBtn) nextBtn.classList.remove('cb-quiz-next--ready');
    }
  }

  document.querySelectorAll('.cb-quiz-step').forEach(step => {
    step.addEventListener('click', function(e) {
      const opt = e.target.closest('.cb-quiz-option');
      if (!opt) return;
      step.querySelectorAll('.cb-quiz-option').forEach(o => o.classList.remove('selected'));
      opt.classList.add('selected');
      const stepNum = parseInt(step.dataset.step);
      const value   = opt.dataset.value;
      const colour  = opt.dataset.colour;
      if (value === '5panel') quizScores['5panel']++;
      if (value === 'washed') quizScores['washed']++;
      if (colour) quizVibe = colour;
      const nextBtn = document.getElementById(`next-${stepNum}`);
      if (nextBtn) {
        nextBtn.disabled = false;
        if (isMobile()) nextBtn.classList.add('cb-quiz-next--ready');
      }
    });
  });

  for (let i = 0; i < totalSteps; i++) {
    const nextBtn = document.getElementById(`next-${i}`);
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        if (i < totalSteps - 1) goToStep(i + 1);
        else showQuizResult();
      });
    }
    const backBtn = document.getElementById(`back-${i}`);
    if (backBtn) backBtn.addEventListener('click', () => goToStep(i - 1));
  }

  function showQuizResult() {
    quizSteps.forEach(s => s.classList.remove('cb-quiz-step--active'));
    quizPips.forEach(p => { p.classList.remove('cb-quiz-pip--active'); p.classList.add('cb-quiz-pip--done'); });
    const resultEl = document.getElementById('cb-quiz-result');
    if (resultEl) resultEl.classList.add('cb-quiz-result--active');

    const capStyle = quizScores['5panel'] >= quizScores['washed'] ? '5panel' : 'washed';
    const colours  = VIBE_COLOURS[quizVibe] || VIBE_COLOURS['neutral'];

    // Build colour swatch row — 1 or 2 swatches
    const colourRow = document.getElementById('cb-result-colour-row');
    if (colourRow) {
      colourRow.innerHTML = colours.map(c => `
        <div class="cb-quiz-result__colour-item">
          <div class="cb-quiz-result__swatch" style="background:${c.hex};"></div>
          <div class="cb-quiz-result__colour-info">
            <div class="cb-quiz-result__cap-type">${CAP_RESULTS[capStyle].type}</div>
            <div class="cb-quiz-result__colour-name">${c.name}</div>
            <div class="cb-quiz-result__colour-desc">${c.desc}</div>
          </div>
        </div>
      `).join('');
    }

    buildQuizResultGrid(CAP_RESULTS[capStyle].filter, colours.map(c => c.name));
  }

  function buildQuizResultGrid(styleFilter, colourNames) {
    const grid = document.getElementById('cb-quiz-result-grid');
    if (!grid) return;
    grid.innerHTML = '';

    const allCards = Array.from(document.querySelectorAll('#cb-bundle-grid .cb-product-card'));
    const styleMatches = allCards.filter(card => {
      const type = card.dataset.productType || '';
      const tags = card.dataset.productTags || '';
      if (styleFilter === '5-panel') return type.includes('5-panel') || tags.includes('5-panel') || tags.includes('5panel');
      if (styleFilter === 'washed')  return type.includes('washed')  || tags.includes('washed');
      return true;
    });

    // One result card per colour
    const toShow = [];
    colourNames.forEach(colourName => {
      const lower = colourName.toLowerCase();
      const match = styleMatches.find(card => {
        const title = (card.querySelector('.cb-product-card__name')?.textContent || '').toLowerCase();
        const tags  = card.dataset.productTags || '';
        return title.includes(lower) || tags.includes(lower);
      });
      if (match && !toShow.includes(match)) toShow.push(match);
    });

    if (toShow.length === 0) styleMatches.slice(0, colourNames.length).forEach(c => toShow.push(c));
    if (toShow.length === 0) {
      grid.innerHTML = '<p style="color:rgba(255,255,255,0.6);font-size:0.9rem;text-align:center;">Browse all caps below to build your bundle.</p>';
      return;
    }

    toShow.forEach((card, idx) => {
      const productId = card.dataset.productId;
      const title     = card.querySelector('.cb-product-card__name')?.textContent || '';
      const img       = card.querySelector('.cb-product-card__img-primary')?.src || '';
      const sizeBtns  = Array.from(card.querySelectorAll('.cb-size-btn:not(.cb-size-btn--sold-out)'));

      const resultCard = document.createElement('div');
      resultCard.className = 'cb-quiz-result-card';

      const sizesHTML = sizeBtns.map(btn =>
        `<button class="cb-quiz-result-card__size-btn" data-variant-id="${btn.dataset.variantId}" data-variant-price="${btn.dataset.variantPrice}" data-size="${btn.dataset.size}">${btn.dataset.size}</button>`
      ).join('');

      resultCard.innerHTML = `
        ${idx === 0 ? '<div class="cb-best-match-badge">Best Match</div>' : ''}
        <img src="${img}" alt="${title}" loading="lazy">
        <div class="cb-quiz-result-card__body">
          <div class="cb-quiz-result-card__name">${title}</div>
          <div class="cb-quiz-result-card__size-grid">${sizesHTML}</div>
          <button class="cb-quiz-result-card__add-btn" disabled data-product-id="${productId}" data-product-title="${title}" data-product-image="${img}">Select a size to add</button>
        </div>
      `;

      resultCard.querySelectorAll('.cb-quiz-result-card__size-btn').forEach(btn => {
        btn.addEventListener('click', function() {
          resultCard.querySelectorAll('.cb-quiz-result-card__size-btn').forEach(b => b.classList.remove('selected'));
          btn.classList.add('selected');
          const addBtn = resultCard.querySelector('.cb-quiz-result-card__add-btn');
          if (addBtn) {
            addBtn.disabled             = false;
            addBtn.textContent          = 'Add to bundle';
            addBtn.dataset.variantId    = btn.dataset.variantId;
            addBtn.dataset.variantPrice = btn.dataset.variantPrice;
            addBtn.dataset.sizeLabel    = btn.dataset.size;
          }
        });
      });

      const addBtn = resultCard.querySelector('.cb-quiz-result-card__add-btn');
      if (addBtn) {
        addBtn.addEventListener('click', function() {
          addToBundle({
            productId: addBtn.dataset.productId,
            variantId: addBtn.dataset.variantId,
            price:     parseInt(addBtn.dataset.variantPrice, 10),
            title:     addBtn.dataset.productTitle,
            image:     addBtn.dataset.productImage,
            size:      addBtn.dataset.sizeLabel,
          }, null, addBtn);
          addBtn.classList.add('cb-quiz-result-card__add-btn--added');
          addBtn.textContent = '✓ Added to bundle';
          syncGridCard(addBtn.dataset.variantId, addBtn.dataset.sizeLabel, true);
        });
      }

      grid.appendChild(resultCard);
    });
  }

  const quizRestartBtn = document.getElementById('cb-quiz-restart');
  if (quizRestartBtn) {
    quizRestartBtn.addEventListener('click', function() {
      quizScores = { '5panel': 0, 'washed': 0 };
      quizVibe   = null;
      const resultEl = document.getElementById('cb-quiz-result');
      if (resultEl) resultEl.classList.remove('cb-quiz-result--active');
      document.querySelectorAll('.cb-quiz-option').forEach(o => o.classList.remove('selected'));
      for (let i = 0; i < totalSteps; i++) {
        const nb = document.getElementById(`next-${i}`);
        if (nb) { nb.disabled = true; nb.classList.remove('cb-quiz-next--ready'); }
      }
      goToStep(0);
    });
  }

  // ─── FILTERS ───────────────────────────────────────────────────────────────
  const productCards = document.querySelectorAll('#cb-bundle-grid .cb-product-card');

  function setFilter(filterKey) {
    document.querySelectorAll('.cb-filter-tab').forEach(btn =>
      btn.classList.toggle('cb-filter-tab--active', btn.dataset.filter === filterKey)
    );
    productCards.forEach(card => {
      let show = true;
      if (filterKey === '5-panel') {
        const type = card.dataset.productType || '';
        const tags = card.dataset.productTags || '';
        show = type.includes('5-panel') || tags.includes('5-panel') || tags.includes('5panel');
      } else if (filterKey === 'washed') {
        const type = card.dataset.productType || '';
        const tags = card.dataset.productTags || '';
        show = type.includes('washed') || tags.includes('washed') || tags.includes('baseball');
      }
      card.classList.toggle('cb-product-card--hidden', !show);
    });
  }

  document.querySelectorAll('.cb-filter-tab').forEach(btn =>
    btn.addEventListener('click', () => setFilter(btn.dataset.filter))
  );

  // ─── SIZE SELECTION ────────────────────────────────────────────────────────
  document.querySelectorAll('#cb-bundle-grid .cb-size-grid').forEach(grid => {
    grid.addEventListener('click', function (e) {
      const btn = e.target.closest('.cb-size-btn');
      if (!btn || btn.disabled) return;
      const productId = grid.dataset.productId;
      const card      = document.querySelector(`#cb-bundle-grid .cb-product-card[data-product-id="${productId}"]`);
      const addBtn    = card ? card.querySelector('.cb-add-btn') : null;
      grid.querySelectorAll('.cb-size-btn').forEach(b => b.classList.remove('cb-size-btn--selected'));
      btn.classList.add('cb-size-btn--selected');
      if (addBtn) {
        addBtn.disabled             = false;
        addBtn.textContent          = 'Add to bundle';
        addBtn.dataset.variantId    = btn.dataset.variantId;
        addBtn.dataset.variantPrice = btn.dataset.variantPrice;
        addBtn.dataset.sizeLabel    = btn.dataset.size;
      }
    });
  });

  // ─── ADD/REMOVE BUNDLE ─────────────────────────────────────────────────────
  document.querySelectorAll('#cb-bundle-grid .cb-add-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      const card = btn.closest('.cb-product-card');
      addToBundle({
        productId:  btn.dataset.productId,
        variantId:  btn.dataset.variantId,
        price:      parseInt(btn.dataset.variantPrice, 10),
        title:      btn.dataset.productTitle,
        image:      btn.dataset.productImage,
        size:       btn.dataset.sizeLabel,
      }, card, btn);
    });
  });

  function addToBundle(item, card, btn) {
    const exists = bundleItems.some(i => i.variantId === item.variantId);
    if (exists) { removeFromBundle(item.variantId); return; }
    bundleItems.push(item);
    if (card) card.classList.add('cb-product-card--selected');
    if (btn && btn.classList.contains('cb-add-btn')) {
      btn.classList.add('cb-add-btn--added');
      btn.textContent = '✓ Added';
    }
    syncGridCard(item.variantId, item.size, true);
    updateBundleUI();
  }

  function removeFromBundle(variantId) {
    bundleItems = bundleItems.filter(i => i.variantId !== variantId);
    syncGridCard(variantId, null, false);
    updateBundleUI();
  }

  function syncGridCard(variantId, sizeLabel, selected) {
    productCards.forEach(card => {
      const sizeBtn = card.querySelector(`.cb-size-btn[data-variant-id="${variantId}"]`);
      if (!sizeBtn) return;
      const addBtn = card.querySelector('.cb-add-btn');
      if (selected) {
        card.querySelectorAll('.cb-size-btn').forEach(b => b.classList.remove('cb-size-btn--selected'));
        sizeBtn.classList.add('cb-size-btn--selected');
        card.classList.add('cb-product-card--selected');
        if (addBtn) {
          addBtn.disabled             = false;
          addBtn.dataset.variantId    = variantId;
          addBtn.dataset.variantPrice = sizeBtn.dataset.variantPrice;
          addBtn.dataset.sizeLabel    = sizeLabel;
          addBtn.classList.add('cb-add-btn--added');
          addBtn.textContent          = '✓ Added';
        }
      } else {
        sizeBtn.classList.remove('cb-size-btn--selected');
        card.classList.remove('cb-product-card--selected');
        if (addBtn) {
          addBtn.classList.remove('cb-add-btn--added');
          addBtn.textContent = 'Add to bundle';
        }
      }
    });
  }

  // ─── UPDATE BUNDLE UI ──────────────────────────────────────────────────────
  const tray      = document.getElementById('cb-tray');
  const trayItems = document.getElementById('cb-tray-items');
  const trayBadge = document.getElementById('cb-tray-badge');
  const trayWas   = document.getElementById('cb-tray-was');
  const trayTotal = document.getElementById('cb-tray-total');

  function updateBundleUI() {
    const qty   = bundleItems.length;
    const tier  = getTier(qty);
    const pct   = tier.pct;

    const origTotal = bundleItems.reduce((s, i) => s + i.price, 0);
    const discTotal = bundleItems.reduce((s, i) => s + applyDiscount(i.price, pct), 0);

    // Show/hide tray
    if (tray) tray.classList.toggle('cb-tray--visible', qty > 0);

    // Render tray items
    if (trayItems) {
      if (qty === 0) {
        trayItems.innerHTML = '<span class="cb-tray__empty">Your bundle is empty — select a cap above</span>';
      } else {
        trayItems.innerHTML = '';
        bundleItems.forEach(item => {
          const div = document.createElement('div');
          div.className = 'cb-tray__item';
          div.innerHTML = `
            ${item.image ? `<img src="${item.image}" alt="${item.title}" class="cb-tray__item-img">` : ''}
            <div class="cb-tray__item-info">
              <span class="cb-tray__item-name">${item.title}</span>
              <span class="cb-tray__item-size">${item.size || ''}</span>
            </div>
            <button class="cb-tray__item-remove" data-variant-id="${item.variantId}" aria-label="Remove">×</button>
          `;
          trayItems.appendChild(div);
        });
        trayItems.querySelectorAll('.cb-tray__item-remove').forEach(btn => {
          btn.addEventListener('click', () => removeFromBundle(btn.dataset.variantId));
        });
      }
    }

    // Pricing
    if (trayBadge) {
      trayBadge.style.display = pct > 0 ? 'inline-block' : 'none';
      trayBadge.textContent   = `${pct}% off applied`;
    }
    if (trayWas)   trayWas.textContent   = pct > 0 ? formatMoney(origTotal) : '';
    if (trayTotal) trayTotal.textContent = formatMoney(pct > 0 ? discTotal : origTotal);

    // Tier highlight
    ['cb-tier-1','cb-tier-2','cb-tier-3'].forEach(id => {
      const el = document.getElementById(id);
      if (el) el.classList.remove('cb-discount-tier--active');
    });
    if (qty >= 3)      { const el = document.getElementById('cb-tier-3'); if (el) el.classList.add('cb-discount-tier--active'); }
    else if (qty === 2) { const el = document.getElementById('cb-tier-2'); if (el) el.classList.add('cb-discount-tier--active'); }
    else if (qty === 1) { const el = document.getElementById('cb-tier-1'); if (el) el.classList.add('cb-discount-tier--active'); }

    // Price display on cards
    productCards.forEach(card => {
      const base   = parseInt(card.dataset.basePrice, 10);
      const origEl = document.getElementById(`orig-${card.dataset.productId}`);
      const saleEl = document.getElementById(`sale-${card.dataset.productId}`);
      if (!origEl) return;
      if (pct > 0 && qty > 0) {
        origEl.classList.add('cb-product-card__was');
        origEl.classList.remove('cb-product-card__orig');
        if (saleEl) { saleEl.style.display = 'inline'; saleEl.textContent = formatMoney(applyDiscount(base, pct)); }
      } else {
        origEl.classList.remove('cb-product-card__was');
        origEl.classList.add('cb-product-card__orig');
        if (saleEl) saleEl.style.display = 'none';
      }
    });

    // Checkout button
    const checkBtn = document.getElementById('cb-checkout-btn');
    const labelEl  = document.getElementById('cb-checkout-label');
    if (checkBtn) {
      checkBtn.disabled = qty === 0;
      if (qty >= 3) checkBtn.classList.add('pulse');
      else checkBtn.classList.remove('pulse');
    }
    if (labelEl) labelEl.textContent = qty === 0
      ? 'Select caps to checkout'
      : `Checkout — ${formatMoney(pct > 0 ? discTotal : origTotal)}`;

    // Nudge
    const nudge = document.getElementById('cb-nudge');
    if (nudge) nudge.style.display = qty === 2 ? 'block' : 'none';
  }

  // ─── CHECKOUT ──────────────────────────────────────────────────────────────
  const checkoutBtn    = document.getElementById('cb-checkout-btn');
  const checkoutLabel  = document.getElementById('cb-checkout-label');
  const checkoutSpinner = document.querySelector('.cb-checkout-spinner');

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', async function () {
      if (bundleItems.length === 0) return;
      checkoutBtn.disabled          = true;
      if (checkoutLabel)  checkoutLabel.style.display   = 'none';
      if (checkoutSpinner) checkoutSpinner.style.display = 'inline';

      const tier      = getTier(bundleItems.length);
      const lineItems = bundleItems.map(item => ({
        variant_id: parseInt(item.variantId, 10),
        quantity:   1,
        applied_discount: tier.pct > 0 ? {
          value_type:  'percentage',
          value:       tier.pct,
          title:       `Bundle ${tier.pct}% off`,
          description: `Banwood Cap Bundle`,
        } : undefined,
      }));

      try {
        const response = await fetch(PROXY_URL, {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ line_items: lineItems, note: `Cap Bundle — ${bundleItems.length} caps`, tags: 'cap-bundle' }),
        });
        if (!response.ok) throw new Error('Draft order failed');
        const data = await response.json();
        if (data.invoice_url) window.location.href = data.invoice_url;
        else throw new Error('No checkout URL');
      } catch (err) {
        console.error('Checkout error:', err);
        alert('Sorry, something went wrong creating your order. Please try again.');
        checkoutBtn.disabled = false;
        if (checkoutLabel)   checkoutLabel.style.display   = 'inline';
        if (checkoutSpinner) checkoutSpinner.style.display = 'none';
      }
    });
  }

  // ─── NUDGE LINK ────────────────────────────────────────────────────────────
  const nudgeLink = document.getElementById('cb-nudge-link');
  if (nudgeLink) {
    nudgeLink.addEventListener('click', function (e) {
      e.preventDefault();
      setFilter('all');
      document.getElementById('cb-builder').scrollIntoView({ behavior: 'smooth' });
    });
  }

  // ─── SHOP THE LOOK HIGHLIGHTS ───────────────────────────────────────────────
  document.querySelectorAll('.cb-look-item').forEach(item => {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      const handles = (item.dataset.handles || '').split(',').map(h => h.trim());
      document.getElementById('cb-builder').scrollIntoView({ behavior: 'smooth' });
      setTimeout(() => {
        productCards.forEach(card => {
          if (handles.includes(card.dataset.productHandle || '')) {
            card.classList.add('cb-product-card--highlighted');
            setTimeout(() => card.classList.remove('cb-product-card--highlighted'), 2000);
          }
        });
      }, 600);
    });
  });

  // ─── INIT ──────────────────────────────────────────────────────────────────
  updateBundleUI();

})();